import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { transformReviewsTemplateToUseProductForContextIfNecessary } from "./defaultComponentTemplate";

export const feraProductRatingWidget: ComponentTemplate = {
  id: "2ea12ad2-5bb7-41eb-8ff8-ae21860b0b76",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Fera Product Rating",
  leftBarCategory: { main: "productIntegrations", subCategory: "fera" },
  preview: "integrations/fera-product-rating.svg",
  transforms: [transformReviewsTemplateToUseProductForContextIfNecessary],
  tags: ["reviews", "star", "widget"],
  template: {
    id: "$uid",
    type: "feraProductRatingWidget",
    props: {},
  },
};
